import { combineReducers } from 'redux';
import list from './list.reducers';
import log from './log.reducers';

const scriptRequestReducers = combineReducers({
  list,
  log,
});

export default scriptRequestReducers;
